import { render, staticRenderFns } from "./TripRatings.vue?vue&type=template&id=77c58966&scoped=true"
import script from "./TripRatings.vue?vue&type=script&lang=js"
export * from "./TripRatings.vue?vue&type=script&lang=js"
import style0 from "./TripRatings.vue?vue&type=style&index=0&id=77c58966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c58966",
  null
  
)

export default component.exports